import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/industries/telecom/page.tsx");
